import { isNonEmptyString } from "@cayuse/shared-react.utils.type-checks";

import { IS_DEV } from "globals/constants";
import { fetchCurrentProjectAccess } from "store/actions/userAccesses";
import { proposal as constants } from "store/constants";
import { actionLoaderFactory } from "store/factories/fetchable";
import { fetchProposal, notifyError } from "utils";
import { dispatch } from "store/store";
import {
	prepareSingleEntityValues,
	updateEntityOrProperty,
	updateEntityAdminTeamMembers,
} from "utils/entityHelpers";

import { api } from "services";
import { proposalSelectors } from "../selectors";
import { getProposalTasks } from "./tasks";
import { setFormEntityData } from "./form";


const proposalFactory = actionLoaderFactory(constants, constants.SINGLE_PROPOSAL);
const proposalValuesFactory = actionLoaderFactory(constants, constants.SINGLE_PROPOSAL_VALUES);

export const setProposalData = payload => {
	proposalFactory.setData({ proposal: payload });
};

export const resetProposal = () => dispatch({ type: constants.RESET });

const onErrorGetProposal = (error, { getState }) => {
	const message = IS_DEV ? error.message : getState().dictionary.proposals.errors.proposalFailedLoad;

	notifyError(message, error)
	proposalFactory.setError(message);
};

export const getProposal = (id, options = { isRefresh: false }) => {
	return proposalFactory.createLoaderAction(
		() => fetchProposal(id),
		[
			(response) => {
				proposalFactory.setData({ proposal: response });
				setFormEntityData({editLock: response.editLock});

				fetchCurrentProjectAccess("proposal");
				getProposalTasks(id);
			},
			onErrorGetProposal,
		],
		options,
	);
};

const onSuccessGetProposalValues = response => {
	const values = prepareSingleEntityValues(response);

	proposalValuesFactory.setData(values);

	return values;
};

const onErrorGetProposalValues = (error, { getState }) => {
	const message = IS_DEV ? error.message : getState().dictionary.proposals.errors.proposalSummaryNotFound;

	notifyError(message, error)
	proposalValuesFactory.setError(message);
};

export const getProposalValues = ({ proposalId, fieldKeys = [] }) => {
	return proposalValuesFactory.createLoaderAction(
		() => api.proposal.getValues(proposalId, { fields: fieldKeys }),
		[
			onSuccessGetProposalValues,
			onErrorGetProposalValues,
		],
	);
};

export const updateProposalAdminTeamMembers = idAdminTeamMemberArray => {
	const proposal = proposalSelectors.proposal();
	const updatedProposal = updateEntityAdminTeamMembers(idAdminTeamMemberArray, proposal);

	proposalFactory.setData({ proposal: { ...proposal, ...updatedProposal } });
};

export const updateProposalOrProperty = (value, property = '') => {
	const proposal = proposalSelectors.proposal();
	const updatedProposal = updateEntityOrProperty(proposalSelectors.proposal())(value, property);

	proposalFactory.setData({ proposal: { ...proposal, ...updatedProposal } });

	return proposal;
};

const onErrorRefresh = error => {
	notifyError(error.message, error);
	proposalFactory.setError(error.message);
};

export const refreshReviewEvents = id => {
	if (isNonEmptyString(id)) {
		return proposalFactory.createLoaderAction(
			() => fetchProposal(id),
			[
				response => {
					updateProposalOrProperty(response?.reviewEvents, "reviewEvents");
					updateProposalOrProperty(response?.certificationEvents, "certificationEvents");
					updateProposalOrProperty(response?.formRules, "formRules");
					updateProposalOrProperty(response?.round, "round");
				},
				onErrorRefresh,
			],
			{ isRefresh: true },
		);
	}
};
